import { getTestAttributes, noop } from '@chillibean/component-library';
import { PropTypes } from 'prop-types';
import { useEffect, useRef } from 'react';

import { scrollIntoView } from '../__util__/scroll';
import HeroBoxHeader from './HeroBoxHeader/HeroBoxHeader';

function HeroBox(props) {
  const {
    backgroundIcon = undefined,
    displayBoxShadow = false,
    headerIcon = undefined,
    headerTitles = undefined,
    cssClass = undefined,
    showClose = false,
    handleClose = noop,
    handleMouseEnter = noop,
    handleClick = noop,
    scrollToView = false,
    children = undefined,
  } = props;

  const heroboxRef = useRef(null);

  useEffect(() => {
    if (scrollToView) scrollIntoView(heroboxRef, 'start');
  }, [scrollToView]);

  const defaultClass = () => {
    return !cssClass || cssClass.length === 0 ? 'hero-box__container--dark-border' : cssClass;
  };

  const conditionalClass = () => {
    if (displayBoxShadow && !backgroundIcon) {
      return 'hero-box__container--box-shadow hero-box__container--allow-overflow';
    }
    if (!displayBoxShadow && backgroundIcon) {
      return 'hero-box__container--display-bg';
    }
    return '';
  };

  const closeIcon = ({ size = 28, color = 'currentColor', iconClass = '', handleOnClick }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={iconClass}
      onClick={handleOnClick}
      {...getTestAttributes('hero-box-close-button')}
    >
      <circle cx="12" cy="12" r="10" />
      <line x1="15" y1="9" x2="9" y2="15" />
      <line x1="9" y1="9" x2="15" y2="15" />
    </svg>
  );

  return (
    <div
      className="hero-box"
      onMouseEnter={handleMouseEnter}
      onClick={handleClick}
      onKeyDown={handleClick}
      ref={heroboxRef}
      role="presentation"
    >
      {showClose && (
        <div>
          <i
            className="fa fa-circle hero-box__container--close hero-box__container--close-background"
            aria-hidden="true"
          />
          {closeIcon({
            iconClass: 'hero-box__container--close',
            handleOnClick: handleClose,
          })}
        </div>
      )}
      <div
        className={`hero-box__container ${defaultClass()} ${
          displayBoxShadow && backgroundIcon
            ? 'hero-box__container--box-shadow hero-box__container--display-bg'
            : conditionalClass()
        }`}
      >
        {headerTitles && <HeroBoxHeader titles={headerTitles} icon={headerIcon} />}

        <div className="hero-box__content">{children}</div>

        {backgroundIcon && (
          <span className="hero-box__bg">
            <i className={`fa ${backgroundIcon}`} aria-hidden="true" />
          </span>
        )}
      </div>
    </div>
  );
}

export default HeroBox;

HeroBox.propTypes = {
  backgroundIcon: PropTypes.string,
  displayBoxShadow: PropTypes.bool,
  headerIcon: PropTypes.shape({
    isSVG: PropTypes.bool,
    headerIcon: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  }),
  headerTitles: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      subTitle: PropTypes.string,
    }),
  ),
  cssClass: PropTypes.string,
  showClose: PropTypes.bool,
  handleClose: PropTypes.func,
  handleMouseEnter: PropTypes.func,
  handleClick: PropTypes.func,
  scrollToView: PropTypes.bool,
  children: PropTypes.node,
};
